import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import dayjs from "../../common/date";
import { backgrounds, borders } from "../../theme/theme";

export default function AdminTimesheetsDetailRow(row: { date: string; numberOfHours: string }, index: number) {
  const date = dayjs(row.date).utc().format("ddd, MMM D, YYYY");
  const isEven = index % 2 === 0;

  return (
    <Box
      key={row.date}
      sx={{
        display: "table",
        width: "100%",
        tableLayout: "fixed",
        py: 1,
        px: 1.5,
        backgroundColor: isEven ? backgrounds.surface : backgrounds.paper,
        borderBottom: `1px solid ${borders.light}`,
        "&:last-child": {
          borderBottom: "none",
        },
      }}
    >
      <Typography variant="body2" component="span" sx={{ display: "table-cell" }}>{date}{'\t'}</Typography>
      <Typography variant="body2" component="span" sx={{ display: "table-cell", fontWeight: 500, textAlign: "right" }}>
        {row.numberOfHours} hrs
      </Typography>
    </Box>
  );
}